import { AnimatePresence, domAnimation, LazyMotion, m } from "framer-motion";
import React from "react";
import "./overlay.scss";
import classNames from "classnames";

export type TOverlay = {
    show?: boolean;
    opacity?: "normal" | "high";
};

export const Overlay = ({ show = false, opacity = "normal", ...props }: TOverlay) => {
    const transition = {
        ease: "easeInOut",
        opacity: { duration: 0.2 },
    };

    const variants = {
        visible: {
            opacity: 1,
            transition,
        },
        hidden: {
            opacity: 0,
            transition,
        },
    };

    return (
        <AnimatePresence>
            {show && (
                <LazyMotion features={domAnimation}>
                    <m.div
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        variants={variants}
                        className={classNames("c-overlay", { "c-overlay--high-opacity": opacity === "high" })}
                        {...props}
                    />
                </LazyMotion>
            )}
        </AnimatePresence>
    );
};

export default Overlay;
